import React from 'react';

import { Tooltip } from 'antd';

import type { Action } from 'v2/interfaces/access-control';

import { Icon } from '@eduzz/ui-antd-theme';

const icons = {
  'abrir-chamado': Icon.CircleHelp,
  'arquivar-produto': Icon.Trash2,
  'cadastrar-produto': Icon.CirclePlus,
  'cancelar-contrato': Icon.CircleX,
  'chat-vip': Icon.MessageSquare,
  'criar-campanha': Icon.CirclePlus,
  'editar-campanha': Icon.Pencil,
  'editar-produto': Icon.Pencil,
  'entrega-manual': Icon.Send,
  'exportar-relatorio': Icon.Download,
  'exportar-resultado': Icon.Download,
  'gerenciar-cupons': Icon.Tag,
  'negociar-faturas': Icon.DollarSign,
  'ocultar-valores': Icon.EyeOff,
  'realizar-venda': Icon.ShoppingCart,
  'reativar-contrato': Icon.ChevronRight,
  'solicitar-transferencia': Icon.DollarSign,
  'solicitar-transferência': Icon.DollarSign,
  'suspender-contrato': Icon.CirclePause,
  'ver-dados-cliente': Icon.User,
  'ver-dados-clientes': Icon.User,
  'visualizar-indicadores': Icon.ChartColumn,
  'acoes': Icon.Ellipsis,
  'adm': Icon.Users,
  'aprovar': Icon.ThumbsUp,
  'criar': Icon.CirclePlus,
  'dashboard': Icon.LayoutDashboard,
  'detalhes': Icon.FileText,
  'editar': Icon.Pencil,
  'excluir': Icon.Trash2,
  'exportar': Icon.Download,
  'manage': Icon.Settings,
  'reembolsar': Icon.RefreshCw,
  'visualizar': Icon.Eye
} as const;

type AccessPolicyIconProps = {
  action: Action;
};

function AccessPolicyIcon({ action }: AccessPolicyIconProps) {
  const iconKey = action.fullname.split(':').pop() as keyof typeof icons | undefined;
  const ActionIcon = (iconKey && icons[iconKey]) || Icon.CircleHelp;

  return (
    <Tooltip placement='top' title={action.name}>
      <span className='inline-flex text-(--uizz-antd-color-text-secondary)'>
        <ActionIcon size={16} />
      </span>
    </Tooltip>
  );
}

export { AccessPolicyIcon };
